import { render, staticRenderFns } from "./DfRating.vue?vue&type=template&id=0609423c&"
import script from "./DfRating.vue?vue&type=script&lang=js&"
export * from "./DfRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports